const autoNgTemplateLoaderTemplate1 = require('./volumesnfsForm.html');

angular.module('portainer.docker').component('volumesNfsForm', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    data: '=',
  },
});
